import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setDone(true);
    } catch (err) {
      toast.error("Could not submit request");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="vbs-auth-bg" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <div className="vbs-card" style={{ width: "100%", maxWidth: 440, padding: 36 }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <span style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 700, color: "var(--white)" }}>
            Reset your password
          </span>
        </div>
        {done ? (
          <div style={{ color: "var(--mid)", textAlign: "center", lineHeight: 1.7 }}>
            If an account exists for <strong style={{ color: "var(--bright)" }}>{email}</strong>, reset instructions have been logged. Check the backend logs for the reset token during this preview.
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <input data-testid="forgot-email" className="vbs-input" type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <button data-testid="forgot-submit" className="vbs-btn vbs-btn-gold" disabled={busy}>
              {busy ? "Sending…" : "Send reset instructions"}
            </button>
          </form>
        )}
        <div style={{ textAlign: "center", marginTop: 20, fontSize: 13, color: "var(--muted)" }}>
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
